import React from 'react'

//Final Form
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

//Material-UI
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTheme from '@material-ui/core/styles/useTheme'

import Button from '../../../../../control/button/button'
import Dialog from '../../../../../control/dialog/dialog'
import TextField from '../../../../../control/textfield/textfield'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import MyAccordion from '../../../../../control/accordion/accordion'

import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../i18n/useTranslate'
import ButtonSubmittedWithdraw from '../_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

import useConfirmProjectWithdraw from './useConfirmProjectWithdraw'

type ConfirmProjectWithdrawViewProps = ReturnType<typeof useConfirmProjectWithdraw> & ConfirmProjectWithdrawProps
const ConfirmProjectWithdrawView: React.FC<ConfirmProjectWithdrawViewProps> = (props) => {
    const {
        initialVal,
        initialUploadFile,
        uploadDocumentTopic,
        isViewMode,
        configDialog,
        onRefDialog,
        onConfirmWithdraw,
    } = props
    const classes = useStyles()
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    return (
        <Form
            onSubmit={() => {}}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={initialVal}
            keepDirtyOnReinitialize={true}
        >
            {({ handleSubmit, form, dirty, invalid, errors, values }) => {
                return (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MyAccordion title={translate.get('LABEL.WITHDRAW_REASON')}>
                                <TextField
                                    name="withdrawCause"
                                    materialInputProps={{
                                        label: translate.get('LABEL.REASON'),
                                        disabled: true,
                                        multiline: true,
                                        rows: 5,
                                    }}
                                    maxLength={1000}
                                    resetButtom
                                />
                            </MyAccordion>
                        </Grid>
                        <Grid item xs={12}>
                            <UploadDoc
                                initialData={initialUploadFile}
                                documentTitleList={uploadDocumentTopic}
                                isViewMode={true}
                                latestDocument={undefined}
                                isUseUploadfileEdit={false}
                            />
                        </Grid>
                        {!isViewMode && (
                            <Grid item xs={12}>
                                <Grid container item justify="space-between" spacing={2}>
                                    <Grid item xs={12} sm={'auto'}>
                                        <ButtonSubmittedWithdraw
                                            gridProps={{ xs: false }}
                                            fullWidth={isMobileView ? true : false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={'auto'}>
                                        <Button
                                            size={'medium'}
                                            variant="contained"
                                            color="primary"
                                            onClick={onConfirmWithdraw}
                                            className={classes.saveButton}
                                            fullWidth={isMobileView ? true : false}
                                        >
                                            {translate.get('BUTTON.SAVE_WITHDRAW')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}

                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </Grid>
                )
            }}
        </Form>
    )
}

export type ConfirmProjectWithdrawProps = {
    onSaveComplete?: (status: number, isDraft: boolean) => void
}
const ConfirmProjectWithdraw: React.FC<ConfirmProjectWithdrawProps> = (props) => {
    const model = useConfirmProjectWithdraw(props)
    return <ConfirmProjectWithdrawView {...model} {...props} />
}

const useStyles = makeStyles((theme) => ({
    saveButton: {
        border: 'solid 1px #db5f8e',
        // [theme.breakpoints.down('xs')]: {
        //     marginTop: '8px',
        // },
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
        [theme.breakpoints.down('xs')]: {
            marginTop: '16px',
        },
    },
    container: {
        padding: '8px 0px',
    },
}))
export default ConfirmProjectWithdraw
